export default class LocalEventNormalizer {
  normalizeBannerName(element) {
    if (!element) return '';

    const altText = this._getAltText(element);

    if (!altText) return '';

    return altText
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase()
      .replace(/[ -]/g, '_')
      .replace(/_{2,}/g, '_');
  }

  normalizeContactLocal(element) {
    if (!element) return '';

    const local = this._getContactLocal(element);

    if (!local) return '';

    return local
      .trim()
      .replace(/ /g, '_')
      .replace(':', '')
      .replace('-', '_')
      .toLowerCase();
  }

  _getAltText(element) {
    return element.getAttribute('alt');
  }

  _getContactLocal(element) {
    const strongElement = element.querySelector('strong');

    return strongElement && strongElement.innerText;
  }
}
